/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { useIntl } from 'react-intl-next';

import { IconButton } from '@atlaskit/button/new';
import { jsx } from '@atlaskit/css';
import Send from '@atlaskit/icon/core/send';
import { fg } from '@atlaskit/platform-feature-flags';
import Tooltip from '@atlaskit/tooltip';

import Enter from '../../assets/Enter';

import messages from './messages';

type Props = {
	disabled: boolean;
	tabIndex?: number;
	onClick?: () => void;
};

export const SubmitButton = ({ disabled, tabIndex, onClick }: Props) => {
	const { formatMessage } = useIntl();

	const icon = fg('platform_editor_new_ai_palette') ? Send : Enter;

	return (
		<Tooltip content={formatMessage(messages.submitTooltip)} hideTooltipOnClick position="top">
			<IconButton
				label={formatMessage(messages.submitLabel)}
				onClick={onClick}
				testId="submit-icon-button"
				isDisabled={disabled}
				icon={icon}
				appearance="subtle"
				spacing="compact"
				tabIndex={tabIndex}
			/>
		</Tooltip>
	);
};
